import Vue from "vue";
import Router from "vue-router";
// import i18n from "@/plugins/i18n";
import { menuConstants } from "@/shared/menuConstant";
import { readACL } from '@/shared/utils'
import { rememberLoginReturnPath } from '@/shared/login-return-path'
import SecureLS from "secure-ls";
var ls = new SecureLS({ encodingType: 'aes' });
const RootContainer = () => import("@/containers/RootContainer");

const Login = () => import("@/views/Auth/Login.vue");
const ResetPasswordRequest = () => import("@/views/Auth/ResetPasswordRequest");
const PractitionerList = () => import("@/views/master/Practitioner/PractitionerList");
const PractitionerRegistration = () => import("@/views/master/Practitioner/PractitionerRegistration");

// Office Menu Component
const CareManagerList = () => import("@/views/Office/CareManagerList");
const CareManagerRegistration = () => import("@/views/Office/CareManagerRegistration");
const BusinessDestinationList = () => import("@/views/Office/BusinessDestination/BusinessDestinationList");
const BusinessDestinationRegistration = () => import("@/views/Office/BusinessDestination/BusinessDestinationRegistration");
const OfficeMaps = () => import("@/views/Office/BusinessDestination/OverAllGoogleMap");
const OfficeGoogleMap = () => import("@/views/Office/BusinessDestination/OfficeGoogleMap");

const CorporateFacilityList = () => import("@/views/Corporate/CorporateFacility/CorporateFacilityList");
const CorporateFacilityRegistration = () => import("@/views/Corporate/CorporateFacility/CorporateFacilityRegistration");
const CorporateFacilityMaps = () => import("@/views/Corporate/CorporateFacility/OverAllGoogleMap");
const CorporateFacilityGoogleMap = () => import("@/views/Corporate/CorporateFacility/CorporateFacilityGoogleMap");

const BaseRegistration = () => import("@/views/Corporate/ResponsibleBase/BaseRegistration");

const BusinessHistoryList = () => import("@/views/Office/BusinessHistory/BusinessHistoryList");
const BusinessHistoryRegistration = () => import("@/views/Office/BusinessHistory/BusinessHistoryRegistration");

// Trial User Menu Component 
const CustomerList = () => import("@/views/Customer/CustomerList");
const CustomerRegistration = () => import("@/views/Customer/CustomerRegistration");


// Master components
const UserList = () => import("@/views/master/Users/UserList")
const UserRegistration = () => import("@/views/master/Users/UserRegistration")
const MedicalInstituteList = () => import("@/views/master/MedicalInstitute/MedicalInstituteList")
const MedicalInstituteRegistration = () => import("@/views/master/MedicalInstitute/MedicalInstituteRegistration")
const DoctorList = () => import("@/views/master/Doctor/DoctorList");
const DoctorRegistration = () => import("@/views/master/Doctor/DoctorRegistration");


const ScreenList = () => import("@/views/master/Screen/ScreenList");
const ScreenRegistration = () => import("@/views/master/Screen/ScreenRegistration");
const ScreenUpdate = () => import("@/views/master/Screen/ScreenUpdate");
const PageNotFound = () => import("@/views/common/404")
const MainFranchiseRegistration = () => import("@/views/master/MainFranchise/MainFranchiseRegistration")
const MainFranchiseList = () => import("@/views/master/MainFranchise/MainFranchiseList")
const SubFranchiseRegistration = () => import("@/views/master/SubFranchise/SubFranchiseRegistration")
const SubFranchiseList = () => import("@/views/master/SubFranchise/SubFranchiseList")

const HanyoMasterList = () => import("@/views/master/HanyoMaster/HanyoMasterList");
const AccessAuthorityList = () => import("@/views/master/AccessAuthority/ScreenAccessAuthorityList");
const AccessAuthorityRegistration = () => import("@/views/master/AccessAuthority/ScreenAccessAuthorityRegistration");

const HojinList = () => import("@/views/master/HojinMaster/HojinList");
const HojinRegistration = () => import("@/views/master/HojinMaster/HojinRegistration");

const HojinInvoiceRegistration = () => import("@/views/master/HojinMaster/HojinInvoiceRegistration.vue")
const Home = () => import("@/views/Auth/Home")
const Forbidden = () => import("@/views/common/403")
Vue.use(Router);

const router = new Router({
	mode: 'history',
	linkActiveClass: "open active",
	scrollBehavior: () => ({ y: 0 }),
	routes: [
		{
			path: "/",
			redirect: "/auth/login",
			meta: {
				requiresAuth: false
			}
		},
		{
			path: "/auth/login",
			name: "login",
			component: Login,
			meta: {
				requiresAuth: false,
				title: "ログイン"
			}
		},
		{
			path: "/auth/reset/password",
			name: "ResetPasswordRequest",
			component: ResetPasswordRequest,
			meta: {
				requiresAuth: false,
				title: "Reset Password"
			}
		},
		{
			path: "/home",
			name: "home",
			component: Home,
			meta: {
				requiresAuth: true,
				title: "Home"
			}
		},
		{
			path: "/",
			component: RootContainer,
			children: [
				// Office routes
				{
					path: "office",
					name: "officeMain",
					meta: { requiresAuth: true, uID: menuConstants.OFFICE_LIST_MENU, },
					component: {
						render(c) {
							return c("router-view");
						}
					},
					children: [
						// care manager routes
						{
							path: "care-manager",
							name: "careman_list",
							component: CareManagerList,
							meta: {
								title: "ケアマネ一覧",
								requiresAuth: true,
								uID: menuConstants.CARE_MANAGER_LIST_MENU,
								type: "list"
							}
						},
						{
							path: "care-manager/registration",
							name: "careman_registration",
							component: CareManagerRegistration,
							meta: {
								requiresAuth: true,
								title: "ケアマネ登録",
								uID: menuConstants.CARE_MANAGER_LIST_MENU,
								type: "registration"
							}
						},
						{
							path: "care-manager/update/:id",
							name: "careman_edit",
							component: CareManagerRegistration,
							meta: {
								requiresAuth: true,
								title: "ケアマネ更新",
								uID: menuConstants.CARE_MANAGER_LIST_MENU,
								type: "update"
							}
						},
						// Business history routes
						{
							path: "business-history",
							name: "business_history",
							component: BusinessHistoryList,
							meta: {
								title: "営業履歴一覧",
								requiresAuth: true,
								uID: menuConstants.SALES_HISTORY_LIST_MENU,
								type: "list"

							}
						},
						{
							path: "business-history/registration/:id",
							name: "business_history_registration",
							component: BusinessHistoryRegistration,
							meta: {
								requiresAuth: true,
								title: "営業履歴登録",
								uID: menuConstants.SALES_HISTORY_LIST_MENU,
								type: "registration"
							}
						},
						{
							path: "business-history/registration/:corporate_facility_id",
							name: "business_history_registration_for_facility",
							component: BusinessHistoryRegistration,
							meta: {
								requiresAuth: true,
								title: "営業履歴登録",
								uID: menuConstants.SALES_HISTORY_LIST_MENU,
								type: "registration"
							}
						},
						{
							path: "business-history/update/:business_history_id",
							name: "business_history_update",
							component: BusinessHistoryRegistration,
							meta: {
								requiresAuth: true,
								title: "営業履歴更新",
								uID: menuConstants.SALES_HISTORY_LIST_MENU,
								type: "update"
							}
						},
						// business destination routes
						{
							path: "business-destination/list",
							name: "business_destination",
							component: BusinessDestinationList,
							meta: {
								requiresAuth: true,
								title: "事業所リスト",
								uID: menuConstants.OFFICE_LIST_MENU,
								type: "list"
							}
						},
						{
							path: "business-destination/registeration",
							name: "business_destination_registration",
							component: BusinessDestinationRegistration,
							meta: {
								requiresAuth: true,
								title: "取引先登録",
								uID: menuConstants.OFFICE_LIST_MENU,
								type: "registration"
							}
						},
						{
							path: "business-destination/update/:business_destination_id",
							name: "business_destination_update",
							component: BusinessDestinationRegistration,
							meta: {
								requiresAuth: true,
								title: "営業履歴更新",
								uID: menuConstants.OFFICE_LIST_MENU,
								type: "update"
							}
						},
						{
							path: "business-destination/OfficeMaps",
							name: "officeMaps",
							component: OfficeMaps,
							meta: {
								requiresAuth: true,
								title: "営業履歴更新",
								uID: menuConstants.OFFICE_LIST_MENU,
								type: "list"
							}
						},
						{
							path: "business-destination/shortest-distance",
							name: "officeGoogleMap",
							component: OfficeGoogleMap,
							meta: {
								requiresAuth: true,
								title: "営業履歴更新",
								uID: menuConstants.OFFICE_LIST_MENU,
								type: "list"
							}
						},



					]
				},

				{
					path: "corporate",
					name: "corporateMain",
					meta: { requiresAuth: true, uID: menuConstants.CORPORATE_FACILITY_LIST_MENU, },
					component: {
						render(c) {
							return c("router-view");
						}
					},
					children: [
						// Corporate facility routes
						{
							path: "corporate-facility/list",
							name: "corporate_facility",
							component: CorporateFacilityList,
							meta: {
								requiresAuth: true,
								title: "法人施設マスタ一覧",
								uID: menuConstants.CORPORATE_FACILITY_LIST_MENU,
								type: "list"
							}
						},
						{
							path: "corporate-facility/registeration",
							name: "corporate_facility_registration",
							component: CorporateFacilityRegistration,
							meta: {
								requiresAuth: true,
								title: "法人施設マスタ登録",
								uID: menuConstants.CORPORATE_FACILITY_LIST_MENU,
								type: "registration"
							}
						},
						{
							path: "corporate-facility/update/:corporate_facility_id",
							name: "corporate_facility_update",
							component: CorporateFacilityRegistration,
							meta: {
								requiresAuth: true,
								title: "法人施設マスタ登録",
								uID: menuConstants.CORPORATE_FACILITY_LIST_MENU,
								type: "update"
							}
						},
						{
							path: "corporate-facility/corporateFacilityMaps",
							name: "corporateFacilityMaps",
							component: CorporateFacilityMaps,
							meta: {
								requiresAuth: true,
								title: "法人施設一覧",
								uID: menuConstants.CORPORATE_FACILITY_LIST_MENU,
								type: "list"
							}
						},
						{
							path: "corporate-facility/shortest-facility-distance",
							name: "corporateFacilityGoogleMap",
							component: CorporateFacilityGoogleMap,
							meta: {
								requiresAuth: true,
								title: "法人施設一覧",
								uID: menuConstants.CORPORATE_FACILITY_LIST_MENU,
								type: "list"
							}
						},

						// Responsible Base routes
						{
							path: "responsible-base/registration",
							name: "responsible_base_registration",
							component: BaseRegistration,
							meta: {
								requiresAuth: true,
								title: "担当拠点登録",
								uID: menuConstants.CORPORATE_FACILITY_LIST_MENU,
								type: "registration"
							}
						},
						{
							path: "responsible-base/update/:responsible_base_id",
							name: "responsible_base_update",
							component: BaseRegistration,
							meta: {
								requiresAuth: true,
								title: "担当拠点登録",
								uID: menuConstants.CORPORATE_FACILITY_LIST_MENU,
								type: "update"
							}
						},

					]
				},

				// Trial User  routes
				{
					path: "trial",
					name: "trialMain",
					meta: {
						requiresAuth: true,
						uID: menuConstants.TRIAL_USER_LIST_MENU,
					},
					component: {
						render(c) {
							return c("router-view");
						}
					},
					children: [
						// customer
						{
							path: "customers",
							name: "customer_list",
							component: CustomerList,
							meta: {
								title: "利用者一覧",
								requiresAuth: true,
								uID: menuConstants.TRIAL_USER_LIST_MENU,
								type: "list"
							}
						},
						{
							path: "customer/create",
							name: "customer_registration",
							component: CustomerRegistration,
							meta: {
								requiresAuth: true,
								title: "利用者情報",
								uID: menuConstants.TRIAL_USER_LIST_MENU,
								type: "registration"
							}
						},
						{
							path: "customer/update/:id",
							name: "customer_edit",
							component: CustomerRegistration,
							meta: {
								requiresAuth: true,
								title: "利用者情報",
								uID: menuConstants.TRIAL_USER_LIST_MENU,
								type: "update"
							}
						}
					]
				},

				// Master routes
				{
					path: "master",
					name: "masterMain",
					meta: { requiresAuth: true },
					component: {
						render(c) {
							return c("router-view");
						}
					},
					children: [
						// practitioner master
						{
							path: "practitioner/list",
							name: "practitioner_master",
							component: PractitionerList,
							meta: {
								requiresAuth: true,
								title: "施術家一覧",
								uID: menuConstants.PRACTITIONER_LIST_MENU,
								type: "list"
							}
						},
						{
							path: "practitioner/registration",
							name: "practitioner_registration",
							component: PractitionerRegistration,
							meta: {
								requiresAuth: true,
								title: "施術家登録",
								uID: menuConstants.PRACTITIONER_LIST_MENU,
								type: "registration"
							}
						},
						{
							path: "practitioner/update/:id",
							name: "practitioner_update",
							component: PractitionerRegistration,
							meta: {
								requiresAuth: true,
								title: "施術家更新",
								uID: menuConstants.PRACTITIONER_LIST_MENU,
								type: "update"
							}
						},

						// users master
						{
							path: "user/list",
							name: "user_master",
							component: UserList,
							meta: {
								requiresAuth: true,
								title: "ユーザー一覧",
								uID: menuConstants.USER_LIST_MENU,
								type: "list"
							}
						},
						{
							path: "user/registration",
							name: "user_registration",
							component: UserRegistration,
							meta: {
								requiresAuth: true,
								title: "ユーザー登録",
								uID: menuConstants.USER_LIST_MENU,
								type: "registration"
							}
						},
						{
							path: "user/update/:id",
							name: "user_update",
							component: UserRegistration,
							meta: {
								requiresAuth: true,
								title: "ユーザー更新",
								uID: menuConstants.USER_LIST_MENU,
								type: "update"
							}
						},

						// medical-institute master
						{
							path: "medical-institute/list",
							name: "medical_institute_master",
							component: MedicalInstituteList,
							meta: {
								requiresAuth: true,
								title: "医療機関一覧",
								uID: menuConstants.MEDICAL_INSTITUTE_LIST_MENU,
								type: "list"
							}
						},
						{
							path: "medical-institute/registration",
							name: "medical_institute_registration",
							component: MedicalInstituteRegistration,
							meta: {
								requiresAuth: true,
								title: "医療機関登録",
								uID: menuConstants.MEDICAL_INSTITUTE_LIST_MENU,
								type: "registration"
							}
						},
						{
							path: "medical-institute/update/:id",
							name: "medical_institute_update",
							component: MedicalInstituteRegistration,
							meta: {
								requiresAuth: true,
								title: "医療機関更新",
								uID: menuConstants.MEDICAL_INSTITUTE_LIST_MENU,
								type: "update"
							}
						},

						// doctor masters
						{
							path: "doctor/list",
							name: "doctor_master",
							component: DoctorList,
							meta: {
								requiresAuth: true,
								title: "医師一覧",
								uID: menuConstants.DOCTOR_LIST_MENU,
								type: "list"
							}
						},
						{
							path: "doctor/registration",
							name: "doctor_registration",
							component: DoctorRegistration,
							meta: {
								requiresAuth: true,
								title: "医師登録",
								uID: menuConstants.DOCTOR_LIST_MENU,
								type: "registration"
							}
						},
						{
							path: "doctor/update/:id",
							name: "doctor_update",
							component: DoctorRegistration,
							meta: {
								requiresAuth: true,
								title: "医師更新",
								uID: menuConstants.DOCTOR_LIST_MENU,
								type: "update"
							}
						},
						{
							path: "doctor/registration/:medical_institute_id",
							name: "doctor_registration_blank",
							component: DoctorRegistration,
							meta: {
								requiresAuth: true,
								title: "医師更新",
								uID: menuConstants.DOCTOR_LIST_MENU,
								type: "update"
							}
						},

						// screen masters
						{
							path: "screen/list",
							name: "screens",
							component: ScreenList,
							meta: {
								requiresAuth: true,
								title: "画面マスタ一覧",
								uID: menuConstants.SCREEN_LIST_MENU,
								type: "list"
							}
						},
						{
							path: "screen/registration",
							name: "screen_registration",
							component: ScreenRegistration,
							meta: {
								requiresAuth: true,
								title: "画面マスタ登録",
								uID: menuConstants.SCREEN_LIST_MENU,
								type: "registration"
							}
						},
						{
							path: "screen/update/:id",
							name: "screen_update",
							component: ScreenUpdate,
							meta: {
								requiresAuth: true,
								title: "画面マスタ更新",
								uID: menuConstants.SCREEN_LIST_MENU,
								type: "update"
							}
						},

						// main franchise masters
						{
							path: "franchise/list",
							name: "franchise_list",
							component: MainFranchiseList,
							meta: {
								requiresAuth: true,
								title: "基幹店一覧",
								uID: menuConstants.MAIN_FRANCHISE_LIST_MENU,
								type: "list"
							}
						},
						{
							path: "franchise/registration",
							name: "franchise_registration",
							component: MainFranchiseRegistration,
							meta: {
								requiresAuth: true,
								title: "基幹店登録",
								uID: menuConstants.MAIN_FRANCHISE_LIST_MENU,
								type: "registration"
							}
						},
						{
							path: "franchise/update/:id",
							name: "franchise_update",
							component: MainFranchiseRegistration,
							meta: {
								requiresAuth: true,
								title: "基幹店更新",
								uID: menuConstants.MAIN_FRANCHISE_LIST_MENU,
								type: "update"
							}
						},

						// sub franchise masters
						{
							path: "sub-franchise/list",
							name: "sub_franchise_list",
							component: SubFranchiseList,
							meta: {
								requiresAuth: true,
								title: "拠点一覧",
								uID: menuConstants.SUB_FRANCHISE_LIST_MENU,
								type: "list"
							}
						},
						{
							path: "sub-franchise/registration",
							name: "sub-franchise",
							component: SubFranchiseRegistration,
							meta: {
								requiresAuth: true,
								title: "拠点登録",
								uID: menuConstants.SUB_FRANCHISE_LIST_MENU,
								type: "registration"
							}
						},
						{
							path: "sub-franchise/add-sub-franchise/:main_franchise_id",
							name: "sub_franchise_registration",
							component: SubFranchiseRegistration,
							meta: {
								requiresAuth: true,
								title: "拠点登録",
								uID: menuConstants.SUB_FRANCHISE_LIST_MENU,
								type: "registration"
							}
						},
						{
							path: "sub-franchise/update/:sub_franchise_id",
							name: "sub_franchise_update",
							component: SubFranchiseRegistration,
							meta: {
								requiresAuth: true,
								title: "拠点更新",
								uID: menuConstants.SUB_FRANCHISE_LIST_MENU,
								type: "update"
							}
						},

						// Hanyo masters
						{
							path: "hanyo-master/list",
							name: "hanyo_master_list",
							component: HanyoMasterList,
							meta: {
								requiresAuth: true,
								title: "汎用マスタ",
								uID: menuConstants.GENERAL_PURPOSE_LIST_MENU,
								type: "list"
							}
						},
						{
							path: "hanyo-master/update/:id",
							name: "hanyo_master_update",
							component: HanyoMasterList,
							meta: {
								requiresAuth: true,
								title: "Hanyo master Update",
								uID: menuConstants.GENERAL_PURPOSE_LIST_MENU,
								type: "update"
							}

						},
						// Access Authority masters
						{
							path: "access-authority/list",
							name: "access_authority_list",
							component: AccessAuthorityList,
							meta: {
								requiresAuth: true,
								title: "画面アクセス権限一覧",
								uID: menuConstants.ACCESS_AUTHORITY_LIST_MENU,
								type: "list"
							}
						},
						{
							path: "access-authority/registration",
							name: "access_authority_registration",
							component: AccessAuthorityRegistration,
							meta: {
								requiresAuth: true,
								title: "画面アクセス権限登録",
								uID: menuConstants.ACCESS_AUTHORITY_LIST_MENU,
								type: "registration"
							}
						},
						{
							path: "access-authority/update/:id",
							name: "access_authority_update",
							component: AccessAuthorityRegistration,
							meta: {
								requiresAuth: true,
								title: "画面アクセス権限更新",
								uID: menuConstants.ACCESS_AUTHORITY_LIST_MENU,
								type: "update"
							}
						},
						//Hojin master routes
						{
							path: "hojin/list",
							name: "hojin_list",
							component: HojinList,
							meta: {
								requiresAuth: true,
								title: "法人情報",
								uID: menuConstants.HOJIN_MASTER_LIST_MENU,
								type: "list"
							}
						},
						{
							path: "hojin/registration",
							name: "hojin_registration",
							component: HojinRegistration,
							meta: {
								requiresAuth: true,
								title: "法人情報",
								uID: menuConstants.HOJIN_MASTER_LIST_MENU,
								type: "registration"
							}
						},
						{
							path: "hojin/update/:id",
							name: "hojin_update",
							component: HojinRegistration,
							meta: {
								requiresAuth: true,
								title: "法人情報",
								uID: menuConstants.HOJIN_MASTER_LIST_MENU,
								type: "update"
							}
						},
						{
							path: "hojin/invoice-registration",
							name: "hojin_invoice_registration",
							component: HojinInvoiceRegistration,
							meta: {
								requiresAuth: true,
								title: "法人情報",
								uID: menuConstants.HOJIN_MASTER_LIST_MENU,
								type: "registration"
							}
						},
						{
							path: "hojin-invoice/update/:id",
							name: "hojin_invoice_update",
							component: HojinInvoiceRegistration,
							meta: {
								requiresAuth: true,
								title: "法人情報",
								uID: menuConstants.HOJIN_MASTER_LIST_MENU,
								type: "update"
							}
						},
					]
				},
			]
		},
		{
			path: "/page-not-found",
			name: "page_not_found",
			component: PageNotFound,
			meta: {
				requiresAuth: false,
				title: "ページが見つかりません"
			}
		},
		{
			path: "/forbidden",
			name: "forbidden",
			component: Forbidden,
			meta: {
				requiresAuth: false,
				title: "禁断"
			}
		},
	]
});
/* Before redirecting to respective page. checking permission */
router.beforeEach((to, from, next) => {
	let permission
	const title = to.meta.title
	let roles = [1, 2];
	// If the route has a title, set it as the page title of the document/page
	if (title) {
		document.title = "KEiLOG"
	}
	if (to.meta.requiresAuth == true) {
		if (localStorage.getItem("token") == null) {
			// Signing in returns here instead of the role's default page (links into KEiLOG).
			rememberLoginReturnPath(window.sessionStorage, to.fullPath);
			next({ name: "login" });
		} else {
			if (to.name != "login") {
				permission = readACL(to.meta.uID);
			}

			if (to.name == "home") {
				next();
			} else {
				if (!roles.includes(ls.get("role")) && !ls.get("selectedFranchise")) {
					localStorage.clear();
					ls.removeAll()
					next({ name: "login" });
				}
				if (!permission) {
					next({ name: "forbidden" });
				} else {
					if (to.meta.type == "list" && permission.select == 1) {
						next();
					} else if ((to.meta.type == "registration" && (permission.insert == 1 || permission.select == 1)) || (to.meta.type == "update" && (permission.update == 1 || permission.select == 1))) {
						next();
					} else {
						next({ name: "forbidden" });
					}
				}
			}

		}
	} else {
		next();
	}
});
export default router;
